import React, { useState } from "react";
import { motion } from "framer-motion";
import { FaPaperPlane, FaSpinner } from "react-icons/fa";
import "../styles/MoodInput.css";

const MoodInput = ({ onSubmitMood, isLoading }) => {
  const [mood, setMood] = useState("");
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 600);

  React.useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 600);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (mood.trim()) {
      onSubmitMood(mood);
    }
  };

  return (
    <motion.div
      className="mood-input-container"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay: 0.2 }}
    >
      <div className="glass-card">
        <h2>How are you feeling today?</h2>
        <p>Describe your emotion or what kind of music you'd like to hear</p>
        <form onSubmit={handleSubmit}>
          <div className="input-group">
            <input
              type="text"
              value={mood}
              onChange={(e) => setMood(e.target.value)}
              placeholder="e.g., Feeling happy and energetic..."
              disabled={isLoading}
            />
            {!isMobile && (
              <motion.button
                type="submit"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                disabled={isLoading}
              >
                {isLoading ? <FaSpinner className="spinner" /> : <FaPaperPlane />}
              </motion.button>
            )}
          </div>
          {isMobile && (
            <motion.button
              type="submit"
              className="mobile-send-btn"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              disabled={isLoading}
              style={{ width: '100%', marginTop: '1rem', borderRadius: '30px', fontSize: '1.1rem', padding: '0.9rem 0' }}
            >
              {isLoading ? <FaSpinner className="spinner" /> : 'Send'}
            </motion.button>
          )}
        </form>
        <div className="mood-examples">
          <p>Try: "Feeling relaxed", "Need focus music", "Energetic workout"</p>
        </div>
      </div>
    </motion.div>
  );
};

export default MoodInput;
